import { Overrides } from "@material-ui/core/styles/overrides"
import { buttonsStatesColors } from "../Button/constants"
import { baseTheme } from "../base"

export const MuiIconButton: Overrides["MuiIconButton"] = {
  root: {
    padding: `${baseTheme.spacing()}`,
    ...buttonsStatesColors.noBackgroundDark,
  },
  colorPrimary: buttonsStatesColors.noBackgroundDark,
  colorSecondary: buttonsStatesColors.noBackgroundDark,
}
